import React from 'react';
import PropTypes from 'prop-types';

import Product, { productPropTypes } from './components/Product';

import styles from './product-info.scss';

const ProductsInfo = ({ headline, disclaimer, productLeft, productCenter, productRight }) => (
  <div className={styles.productInfo}>
    <h2>{headline}</h2>

    <div className={styles.productsWrapper}>
      <div className={styles.productsWrapperInner}>
        <div className={styles.products}>

          <div className={styles.productWrapper}>
          </div>

          <div className={styles.centerProductWrapper}>
            <Product attension {...productCenter} />
          </div>

          <div className={styles.productWrapper}>
          </div>

        </div>

        <div className={styles.disclaimer}>
          {disclaimer}
        </div>

      </div>
    </div>
  </div>
);

ProductsInfo.propTypes = {
  headline: PropTypes.string.isRequired,
  disclaimer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
  productLeft: PropTypes.shape(productPropTypes).isRequired,
  productCenter: PropTypes.shape(productPropTypes).isRequired,
  productRight: PropTypes.shape(productPropTypes).isRequired,
};

export default ProductsInfo;



// WEBPACK FOOTER //
// ./blocks/ProductsInfo/index.js